export default {"src":"/_next/static/media/banner3.7bd07c8b.svg","height":140,"width":720,"blurWidth":0,"blurHeight":0};